import React from 'react';
import { Link } from 'react-router-dom';

const Gallery = () => {
  return (
    <div>
      <section className="bg-gradient-to-r from-blue-600 to-green-600 text-white py-16">
        <div className="container mx-auto px-4 text-center">
          <h1 className="text-4xl md:text-5xl font-bold mb-4">Our Work Gallery</h1>
          <p className="text-xl">See our professional pest control services in action</p>
        </div>
      </section>

      <section className="py-16">
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto text-center">
            <div className="text-6xl mb-6">📸</div>
            <h2 className="text-3xl font-bold mb-4">Gallery Coming Soon!</h2>
            <p className="text-xl text-gray-600 mb-8">We&apos;re curating photos of our professional work. Check back soon to see our pest control projects!</p>
            <Link to="/" className="bg-blue-600 text-white px-8 py-3 rounded-lg font-bold hover:bg-blue-700 transition inline-block">Back to Home</Link>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Gallery;